import { message } from "antd";
import InternalApi from "../axios/internalApi";

export const getAllSupportTickets = async ({
  pageNumber = 1,
  itemPerPage = 4,
  text,
}) => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: `admin/list-support-tickets?pageNumber=${
        text ? 1 : pageNumber
      }&itemPerPage=${itemPerPage}${text ? `&text=${text}` : ""}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const updateSupportTicket = async (id, payload) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `admin/support-ticket/${id}`,
      },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateSupportTicketStatus = async (id, status) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `admin/support-tickets/${id}/status`,
      },
      status
    );
  } catch (error) {
    message.error(
      error?.data?.message || "Failed to update ticket status"
    );
    throw error;
  }
};
